import React from 'react';
import styled from '@emotion/styled';
import { Color } from '../../../styles/Color';
import { theme } from '../../../styles/theme';
import { Css, Flex, Responsive, Shimmer } from '../../../ui';
import { PoiCardContainer, PoiImageWrap } from './PoiCard';

export default function PoiCardShimmer() {
	return (
		<ShimmerPoiContainer>
			<PoiImageWrap />
			<ShimmerPoiContent>
				<Flex direction="column" gap="15">
					<RowContainer
						direction="row"
						justifyContent="space-between"
						alignItems="center"
					>
						<ShimmerPoiTitle />
						<ShimmerPoiIcon />
					</RowContainer>
					<ShimmerPoiDescription />
				</Flex>
				<RowContainer
					direction="row"
					justifyContent="space-between"
					alignItems="center"
				>
					<ShimmerPoiBadge />
					<ShimmerPoiButton />
				</RowContainer>
			</ShimmerPoiContent>
		</ShimmerPoiContainer>
	);
}

const RowContainer = styled(Flex)`
	> div {
		background-color: ${Color.BodyBackground};
	}
`;
const StyledShimmer = styled(Shimmer)`
	display: flex;
	justify-content: space-between;
	gap: ${Css.pxToRem(24)};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		gap: ${Css.pxToRem(8)};
	}
`;

const ShimmerPoiContainer = styled(
	PoiCardContainer.withComponent(StyledShimmer),
)`
	justify-content: flex-start;
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
	}
`;

const ShimmerPoiContent = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: ${Css.pxToRem(15)};
	padding-left: 0;
`;

const ShimmerPoiTitle = styled.div`
	width: 70%;
	height: ${Css.pxToRem(24)};
`;
const ShimmerPoiDescription = styled.div`
	width: 70%;
	height: ${Css.pxToRem(16)};
	background-color: ${Color.BodyBackground};
	margin-bottom: ${Css.pxToRem(30)};
`;

const ShimmerPoiIcon = styled.div`
	position: relative;
	width: ${Css.pxToRem(30)};
	height: ${Css.pxToRem(30)};
	margin-left: auto;
	border-radius: ${theme.shimmer?.placeholder?.borderRadius};
`;

const ShimmerPoiBadge = styled.div`
	width: ${Css.pxToRem(111)};
	height: ${Css.pxToRem(24)};
	border-radius: ${theme.shimmer?.placeholder?.borderRadius};
`;

const ShimmerPoiButton = styled.div`
	width: ${Css.pxToRem(24)};
	height: ${Css.pxToRem(24)};
	border-radius: ${theme.shimmer?.placeholder?.borderRadius};
	margin-left: auto;
	margin-top: ${Css.pxToRem(4)};
`;
